import logParams from 'helpers/logParams'
import {Pure} from 'components/Pure'
import React, {useEffect, useRef, useState} from 'react'
import useKey from 'react-use/lib/useKey'
import classNames from "classnames";

export const SelectList = ({ children = [], onSelected = logParams, className, }) => {
  const [version, setVersion] = useState(Date.now())
  const ref = useRef({
    selectedkey: 0,
  })
  useEffect(() => {
    ref.current.children = children
    ref.current.length = children.length
    ref.current.selectedkey = Math.min(
      ref.current.selectedkey,
      children.length - 1
    )
    setVersion(Date.now())
  }, [children])
  useKey('ArrowUp', () => {
    ref.current.selectedkey =
      (ref.current.length - 1 + ref.current.selectedkey) % ref.current.length
    setVersion(Date.now())
  })
  useKey('Enter', () => {
    onSelected(
      ref.current.children[ref.current.selectedkey],
      ref.current.selectedkey
    )
  })
  useKey('ArrowDown', () => {
    ref.current.selectedkey =
      (ref.current.length + 1 + ref.current.selectedkey) % ref.current.length
    setVersion(Date.now())
  })
  return (
    <Pure input={[version]}>
      <div className={classNames("space-y-1", className)}
        // style={{
        //   [`--background-${ref.current.selectedkey}`]: 'var(--background-50)',
        // }}
      >
        {children.map((e, index) => (
          <div
            style={{
              background: `var(--background-${index})`,
              borderBottom: index === 0 && 'solid 1px var(--border-color-50)',
            }}
            key={index}>
            {e}
          </div>
        ))}
      </div>
    </Pure>
  )
}
